import { useDispatch } from 'react-redux';

import { IStore } from './store';

/**
 * As recommended by the description on the `useDispatch` type:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/dfec9e88385b279a94076c46a1cc4527ae657532/types/react-redux/index.d.ts#L516
 */
export const useThunkDispatch = () => useDispatch<IStore['dispatch']>();
